module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "advert-manage"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('span', [_vm._v("信息流广告 > ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.advertTitle))]), _vm._v("的信息流广告\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancle
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addNewAdvert()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('el-select', {
    staticClass: "com-select",
    model: {
      value: (_vm.osType),
      callback: function($$v) {
        _vm.osType = $$v
      },
      expression: "osType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "安卓",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IOS",
      "value": "2"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "com-select",
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已上线",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "待上线",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "草稿",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "过期",
      "value": "4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "搜索名称关键字"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStramAdlist.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.keyWord),
      callback: function($$v) {
        _vm.keyWord = $$v
      },
      expression: "keyWord"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getStramAdlist
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.advertList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "广告标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "description",
      "label": "广告说明"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "osType",
      "label": "终端"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicableCampus",
      "label": "适用学校"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "grade",
      "label": "等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "showtime",
      "label": "有效时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status == 1) ? _c('span', [_vm._v("草稿")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 2) ? _c('span', [_vm._v("待上线")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 3) ? _c('span', [_vm._v("已上线")]) : _vm._e(), _vm._v(" "), (_vm.row.status == 4) ? _c('span', [_vm._v("过期")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "latestdo",
      "label": "最近操作记录",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "160"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "btn-box"
          }, [(_vm.row.status == 3) ? _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.offLineAdvert(_vm.row)
              }
            }
          }, [_vm._v("下线")]) : _vm._e(), _vm._v(" "), (_vm.row.status != 3) ? _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.addNewAdvert(_vm.row.id)
              }
            }
          }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.row.status != 3) ? _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.deleteAdvert(_vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toStatisData(_vm.row)
              }
            }
          }, [_vm._v("数据")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "current-page": _vm.pageNum,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66e99619!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/advert/advertManage.vue
// module id = 1056
// module chunks = 0